import React from "react";

const Hero = () => {
  return (
    <div className="relative h-screen overflow-hidden">
      {/* Background Image Overlay */}
      <div className="absolute inset-0">
        <div className="w-full h-full bg-gradient-to-br from-gray-900 via-black to-gray-800"></div>
        <div className="absolute inset-0 opacity-10">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `
                  linear-gradient(45deg, transparent 25%, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.1) 50%, transparent 50%, transparent 75%, rgba(255,255,255,0.1) 75%),
                  linear-gradient(-45deg, transparent 25%, rgba(255,255,255,0.05) 25%, rgba(255,255,255,0.05) 50%, transparent 50%, transparent 75%, rgba(255,255,255,0.05) 75%)
              `,
              backgroundSize: "60px 60px",
            }}
          ></div>
        </div>
      </div>

      {/* Abstract geometric overlay */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-1/4 w-72 sm:w-80 lg:w-96 h-72 sm:h-80 lg:h-96 border border-white transform rotate-45 opacity-30"></div>
        <div className="absolute bottom-1/4 right-1/4 w-56 lg:w-64 h-56 lg:h-64 border border-white transform -rotate-12 opacity-20"></div>
        <div className="absolute top-1/2 right-1/3 w-24 sm:w-28 lg:w-32 h-24 sm:h-28 lg:h-32 bg-white transform rotate-45 opacity-10"></div>
      </div>

      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center max-w-6xl mx-auto px-6">
          <div className="mb-12 lg:mb-16">
            {/* Top label – keep it subtle on all screens */}
            <p className="text-[9px] sm:text-xs md:text-[11px] tracking-[0.3em] uppercase text-gray-300 mb-8 lg:mb-12">
              Our Story • Our Mission • Our Vision
            </p>

            {/* Staggered title layout */}
            <div className="space-y-4 mb-10 lg:mb-12">
              {/* ABOUT – scaled more gently */}
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-thin tracking-tight leading-none text-white">
                ABOUT
              </h1>

              <div className="flex items-center justify-center gap-4 sm:gap-6 lg:gap-8">
                <div className="w-16 sm:w-20 lg:w-24 h-px bg-gray-400"></div>
                {/* FROST & GREY – slightly smaller than ABOUT for hierarchy */}
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-thin tracking-tight leading-none text-transparent bg-clip-text bg-gradient-to-r from-gray-300 to-white">
                  FROST & GREY
                </h1>
                <div className="w-16 sm:w-20 lg:w-24 h-px bg-gray-400"></div>
              </div>
            </div>

            {/* Subtitle – toned down a bit */}
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-thin tracking-wide text-gray-200 mb-10 lg:mb-12">
              Empowering the <em>AI Era</em>
            </h2>
          </div>

          {/* Mission statement in a box */}
          <div className="border border-gray-600 p-6 sm:p-8 md:p-10 lg:p-12 backdrop-blur-sm bg-black bg-opacity-20">
            <p className="text-sm sm:text-base md:text-lg leading-relaxed max-w-4xl mx-auto tracking-wide text-gray-100">
              We empower professionals and organizations to boost productivity, automate workflows, and scale with AI,
              <em className="text-gray-300">
                {" "}
                providing practical training and custom implementation for real-world impact.
              </em>
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="flex flex-col items-center text-gray-300">
          <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase mb-2">
            Our journey
          </p>
          <div className="w-px h-8 bg-gray-300 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
